import { SystemVersionDetailsAPI } from "../adapters/SystemVersionDetailsAdapter/SystemVersionDetailsAdapter";
export const getSystemVersionDetails = () => {

    var promise = new Promise(function (resolve, reject) {
        SystemVersionDetailsAPI().then((res) => {
            if (res && res.data && res.status === 200) {
                let response = res.data;
                console.log("Helper SYstem Details", response.data);
                resolve(response);
            } else {
                if (res && res.data && res.data.error && res.data.error.message) reject(res.data.error.message);
                else reject("error occured");
            }
        }).catch((err) => {
            reject(err);
        });
    })

    return promise;
};